/**
 * Parses query string for Fund Finder filters which are expected
 * to be JSON encoded arrays of integers
 * Should return an empty array when unexpected values are found
 *
 * @param {URLSearchParams} urlSearchParams
 * @param {string} filterName
 */
export function getFundFinderFilterValue (urlSearchParams, filterName) {
    const rawFilterValue = urlSearchParams.get(filterName);

    if (!rawFilterValue) {
        return [];
    }

    try {
        const parsedFilterValue = JSON.parse(rawFilterValue);

        if (!Array.isArray(parsedFilterValue)) {
            return [];
        }

        const filteredFilterValue = parsedFilterValue.filter(Number.isInteger);

        if (parsedFilterValue.length !== filteredFilterValue.length) {
            return [];
        }

        return filteredFilterValue;
    } catch (e) {
        return [];
    }
}



// WEBPACK FOOTER //
// ./src/js/app/fund-finder/get-fund-finder-filter-value.js